"use client";
import React from "react";
import { TurnrTableCell, TurnrTableRow } from "~/components/table/TurnrTableSmart.jsx";
import { TableCellDateTime } from "~/components/table/cells/TableCellDateTime.jsx";
import { TableCellReturnItems } from "~/components/table/cells/TableCellReturnItems.jsx";
import TableCellShippingMethod from "~/components/table/cells/TableCellShippingMethod.jsx";
import { CHIP_COLOR_TYPES, CustomChip } from "~/components/chips/CustomChip.jsx";

export default function ShipmentOrReturnRow({
    appProps,
    orderReturn,
    shipment,
    highlightText,
    // order, qualityCheckOrderRows, onReportOnChange
}) {
    // const onClick = useCallback(() => {
    //     onReportOnChange(order?.id, orderReturn?.id, shipment?.id);
    // }, [onReportOnChange]);

    const returnStatusLabel = orderReturn?.alreadyHandled && orderReturn?.statusLabel;

    return (
        <TurnrTableRow
            style={{
                borderLeft: "1px solid #e1e3e5",
                borderBottom: "none",
            }}
            darkerHover={true}
        >
            <TurnrTableCell tight={true} className={"sm-hide"} rowClick={true}>
                <div
                    style={{
                        minWidth: "50px",
                        minHeight: "30px",
                        fontSize: "11px",
                        display: "flex",
                        alignItems: "center",
                    }}
                    className={"muted"}
                >
                    {shipment ? "Shipment" : "Return"}
                </div>
            </TurnrTableCell>

            <TableCellShippingMethod
                appProps={appProps}
                darkerHover={true}
                showShippingMethod={false}
                highlightText={highlightText}
                iconClassName={"xs-hide"}
                style={{
                    width: "200px",
                    minHeight: "30px",
                }}
                shipment={shipment}
                orderReturn={orderReturn}
                tight={true}
            />
            <TableCellDateTime tight={true} darkerHover={true} className={"xl-hide"} style={{ width: "110px" }} dateTime={orderReturn?.createdAt} />
            <TableCellReturnItems
                darkerHover={true}
                WrapperComponent={({ children }) => <div style={{ minWidth: "73px" }}>{children}</div>}
                className={"xl-hide"}
                appProps={appProps}
                orderReturn={orderReturn}
            />
            <TurnrTableCell tight centerContent style={{ minWidth: "150px" }} className={"sm-hide"}>
                {returnStatusLabel && <CustomChip size={"small"} label={returnStatusLabel} colorType={CHIP_COLOR_TYPES.DONE} />}
            </TurnrTableCell>
        </TurnrTableRow>
    );
}
